import { Box, Grid } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";
import { dateFormatterWithTime } from "../../helper/losDataHelper";

const QueryList = ({ queryDetails }) => {

    const queryListColumns = [
        {
            field: "queryId",
            headerName: "Query ID",
            headerAlign: "center",
            align: "center",
            flex: 200,
            type: "string",
            editable: false,
          },
            {
              field: "internalapplicationid",
              headerName: "Internal Application ID",
              headerAlign: "center",
              align: "center",
              flex: 200,
              type: "string",
              editable: false,
            },
            {
                field: "applicationNumber",
                headerName: "Application Number",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "queryRaisedTo",
                headerName: "Query Raised To",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "queryRaisedBy",
                headerName: "Query Raised By",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "queryDescription",
                headerName: "Query Description",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "queryResolveDescription",
                headerName: "Query Resolve Description",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "resolvedDatetime",
                headerName: "Resolved Datetime",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
                valueGetter: (params) => dateFormatterWithTime(params.row.resolvedDatetime)
              },
              {
                field: "creationDatetime",
                headerName: "Creation Datetime",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
                valueGetter: (params) => dateFormatterWithTime(params.row.creationDatetime)
              },
              {
                field: "queryStatus",
                headerName: "Query Status",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              }
    ];

    return(<>
         <AccordianContainer
          id="accord"
          title="Query Details"
          initialOpen={false}
        >
          <Box sx={{ marginTop: "-0.5%" }}>
          <CustomDataGrid
            noDataMessage="No Data"
            rows={(queryDetails !== undefined && queryDetails !== null) ?
              queryDetails.map((item, index) => ({
                id: index + 1,
                ...item,
              })) : []}
            columns={queryListColumns}
            pageSize={15}
            pageSizeOptions={[10]}
            gridLazyLoad={() => {}}
            gridHeight={305}
            getRowId={(row) => row.queryId}
            onCellKeyDown={(event, param) => {
              (param.key === "e" || param.key === "E") &&
                param.preventDefault();
            }}
          />
          </Box>
          </AccordianContainer>
    </>);
}

export default QueryList;